export function orderRouteRecords(data) {
  const records = (Array.isArray(data) ? data : []).map((activity, originalIndex) => ({
    activity,
    originalIndex
  }))
  const timestamps = records.map(({ activity }) => Date.parse(activity?.created_date))
  const dated = records
    .filter((record) => Number.isFinite(timestamps[record.originalIndex]))
    .sort(
      (a, b) =>
        timestamps[a.originalIndex] - timestamps[b.originalIndex] ||
        a.originalIndex - b.originalIndex
    )

  // Preserve each undated record's original slot while sorting the dated records around it.
  let nextDated = 0
  return records.map((record) =>
    Number.isFinite(timestamps[record.originalIndex]) ? dated[nextDated++] : record
  )
}
